const CookieNotification = (() => {
  const DOM = {};

  const cacheDOM = () => {
    DOM.cookieNotificationElement = document.getElementsByClassName(
      "cookie-notification"
    )[0];
    DOM.cookieNotificationBtn = document.getElementsByClassName(
      "cookie-notification__buttons__accept"
    )[0];
  };

  const displayCookieNotification = () => {
    if (DOM.cookieNotificationElement) {
      const checkCookie = localStorage.getItem("cookie-notification");

      if (checkCookie === null) {
        DOM.cookieNotificationElement.classList.add(
          "cookie-notification--visible"
        );
      }
    }
  };

  const acceptCookie = () => {
    localStorage.setItem("cookie-notification", "true");
    DOM.cookieNotificationElement.classList.remove(
      "cookie-notification--visible"
    );
  };

  const eventListener = () => {
    DOM.cookieNotificationBtn.addEventListener("click", acceptCookie);
  };

  const init = () => {
    cacheDOM();
    displayCookieNotification();
    eventListener();
  };

  return {
    init: init,
  };
})();

export default CookieNotification;
